/**
 * @fileoverview GET handler for the "/engagement/expressive_report/:report_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementExpressiveReportReportId } from "./constants";
import type { EngagementQueryBuilderReportResult } from "./types";

export const getEngagementQueryBuilderReport = reactQueryFetcherAdapter(
  engagementExpressiveReportReportId,
  (signal: AbortSignal, reportId: string): Promise<EngagementQueryBuilderReportResult> => {
    return fetch(`/engagement/expressive_reports/${reportId}`, "GET", {}, { signal });
  }
);
